import React from 'react';
import { Save } from 'lucide-react';

const SaveButton = ({ onClick, className = '', variant = 'default', ...props }) => (
  <button
    onClick={onClick}
    className={`flex items-center justify-center w-10 h-10 rounded-full transition ${
      variant === 'green'
        ? 'bg-green-600 hover:bg-green-700 text-white'
        : 'bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-gray-900'
    } ${className}`}
    {...props}
  >
    <Save className="h-5 w-5" />
  </button>
);

export default SaveButton; 